import React, { useEffect, useState } from 'react';
import styles from './HeroSection.module.scss';
import { crBadge, demoDayBuilding, demoDayBuildingFull, locationicon, partnerdrapperlogo, partnerkarostartuplogo, partnerrazorpaylogo, scheduleicon } from 'src/assets/images';
import { Button, ConfirmModal } from 'src/components/common';
import { useAppDispatch, useAppSelector } from 'src/store/hooks';
import { Link, useNavigate } from 'react-router-dom';

const DemoDayHeroSection = () => {
    const navigate = useNavigate()
    const { demoDay, myVenture, loading, globalDemoDay } = useAppSelector(
        (store) => store.venture
    );
    const isAuthorized: boolean = useAppSelector((store) => store.auth.isAuthorized);

    // state 
    const [show, setShow] = useState<boolean>(false);
    const buttonArray = ['', 'Submit Your Deck & Get Noticed', 'Book Your Slot for Round 1', 'You are In! View Your Slot']
    const button: number = demoDay?.demoDayProgress === 'Register' ? 1 : demoDay?.demoDayProgress === 'Pitch Deck' ? 2 : demoDay?.demoDayProgress === 'Done' ? 3 : 0
    const buttonText = buttonArray[button];
    const isDemoDayRunning = !!globalDemoDay?.[0]?.id;
    const endDate = globalDemoDay?.[0]?.endDate || ''
    const registerButton = isDemoDayRunning ? <button className={styles.actionButton} onClick={handleRegister}>Register Now for <del>₹499</del> ₹249</button> : <button className={styles.actionButton} style={button === 0 ? { cursor: 'auto' } : {}} onClick={handleRegister}>Registrations closed</button>
    function handleNavigate() {
        navigate(`/login?prev=${encodeURIComponent('/demo-day')}`)
    }
    console.log(myVenture, '0000000000', demoDay, button);
    function handleRegister() {
        if (button === 0 && !isDemoDayRunning) {
            return
        }
        if (!isAuthorized) {
            return setShow(true)
        }
        
        const path = !myVenture?.id 
        ? `/post-venture?prev=${encodeURIComponent('/demo-day-register/payment')}`
        : myVenture?.draft ? `/post-venture?id=${myVenture?.id}&type=draft&prev=${encodeURIComponent('/demo-day-register/payment')}`
        : button === 0 ? `/demo-day-register/payment?id=${myVenture?.id}` 
        : button === 1 ? `/demo-day-register/document-submission?id=${myVenture?.id}`
        : button === 2 ? `/demo-day-register/slot-booking?id=${myVenture?.id}` 
        : `/demo-day-detail?id=${myVenture?.id}`
        console.log(path, 'patjhdataaaaaaaaa');
        
        navigate(path)
    }
    console.log(globalDemoDay, 'globalDemoDay');

    return (
        <>
            <ConfirmModal
                title=""
                description={<p style={{ display: 'flex', alignItems: 'center', flexDirection: 'column', margin: '0' }}>
                    <span>To register for Demo Day </span>
                    <span><span style={{ color: '#fa4616' }}>Sign in</span> to Continue</span>
                </p>}
                openConfirmModal={show}
                onClose={() => setShow(false)}
                onSubmit={handleNavigate}
                submitText="Sign in"
                type="confirm"
            />
            <section className={`${styles.heroLayout} ${!isAuthorized ? styles.withoutlogin : {}}`}>
                <div className={styles.left}>
                    <div className={styles.content}>
                        <h5 className={styles.heading}>DEMO DAY</h5>
                        <p className={styles.desc1}>For Idea & Early Stage Startups</p>
                        <p className={styles.desc2}>Get Discovered. Get Funded.</p>
                        {isDemoDayRunning && <div className={styles.buttonContainer}>
                            {/* <button><img src={scheduleicon} alt="schedule-icon" /> <span>21st June’25</span></button> */}
                            <button><img src={scheduleicon} alt="schedule-icon" /> <span>{formatDate(endDate)}</span></button>
                            <button><img src={locationicon} alt="schedule-icon" /> <span>Online</span></button>
                        </div>}
                        {button === 0 ? registerButton : <button className={styles.actionButton} onClick={handleRegister}>{buttonText}</button>}
                        {/* {button === 0 ? <button className={styles.actionButton} style={button === 0 ? { cursor: 'auto' } : {}} onClick={handleRegister}>Registrations closed</button> : <button className={styles.actionButton} onClick={handleRegister}>{buttonText}</button>} */}
                        <footer>
                            {/* <p>To register for Demo Day, make sure your startup is showcased on <Link to={'/venture'} className={styles.mobileVentureLink}>Venture Verse</Link></p> */}
                            <p>To register for future Demo Days, make sure your startup is showcased on <Link to={'/venture'} className={styles.mobileVentureLink}>Venture Verse</Link></p>
                            <button onClick={() => navigate('/venture')}>Venture Verse</button>
                        </footer>
                    </div>
                    <img src={crBadge} alt="₹1CR FUNDS Badge" className={styles.crBadge} />
                </div>
                <div className={styles.right}>
                    <h5>What’s  in it for Startups ?</h5>
                    <ul>
                        <li><span>Pitch live</span> to relevant <span>investors</span></li>
                        <li>Attend <span>5 exclusive startup webinars</span></li>
                        <li><span>Get noticed</span> by key ecosystem players</li>
                        <li><span>Exclusive Discount</span> on <span>RazorpayX Payroll</span> & <span> AppOpen </span></li>
                    </ul>
                    <div className={styles.partners}>
                        <h5>ECOSYSTEM PARTNERS</h5>
                        <div className={styles.partnersLogoContainer}>
                            <img src={partnerrazorpaylogo} className={styles.background} alt="Razorpay" />
                            <img src={partnerkarostartuplogo} className={styles.background} alt="KA Startup" />
                            <img src={partnerdrapperlogo} className={styles.drapper} alt="Draper" />
                        </div>
                    </div>
                </div>
                <img src={demoDayBuilding} alt="Building" className={styles.buildingImage} />
                <img src={demoDayBuildingFull} alt="Building" className={styles.buildingImageMobile} />
            </section>
        </>
    );
};

export default DemoDayHeroSection;

function formatDate(dateString: string) {
    if (!dateString) return ''
    const date = new Date(dateString);

    const day = date.getUTCDate();
    const month = date.toLocaleString('default', { month: 'short', timeZone: 'UTC' });
    const year = String(date.getUTCFullYear()).slice(-2);

    const getDaySuffix = (d: number) => {
        if (d > 3 && d < 21) return 'th';
        switch (d % 10) {
            case 1: return 'st';
            case 2: return 'nd';
            case 3: return 'rd';
            default: return 'th';
        }
    };

    const suffix = getDaySuffix(day);

    return `${day}${suffix} ${month}’${year}`;
}
